import React from 'react';
import ListIcon from "presentation/common/components/style-guide/icons/ListIcon";

export const NoRecords = () => {
  return (
    <div className="w-full h-full p-4 flex justify-center items-center flex-col">
        <ListIcon/>
        <h3 className="p-4 text-center">No hay documentos pendientes de firma.</h3>
    </div>
  );
};
